<template>
  <div class="LKPublicationsFormdataHeader">
    <div class="table-actions-wrapper">
      <v-btn
        v-if="useExcel"
        color="primary"
        :outlined="activeTab !== 'excel'"
        depressed
        @click="onExcelClick"
        v-text="'Excel'"
      />
      <template v-if="!close && !readonly">
        <v-btn
          color="primary"
          :outlined="activeTab !== 'form'"
          class="ml-btn"
          @click="onFormClick"
          v-text="'Форма'"
        />
        <v-btn
          v-if="hasScannable"
          color="primary"
          :outlined="activeTab !== 'scan'"
          class="ml-btn"
          @click="onScanClick"
          v-text="'Сканирование'"
        />
      </template>
      <v-spacer />
      <div>
        <div class="table-actions-wrapper">
          <template v-if="activeTab !== 'scan'">
            <v-tooltip bottom :disabled="updated">
              <template #activator="{ on }">
                <div v-on="on">
                  <v-btn
                    v-if="!close && !readonly"
                    :loading="loading"
                    :disabled="!updated"
                    color="primary"
                    outlined
                    rounded
                    @click="$emit('draft:save')"
                    v-text="'Сохранить черновик'"
                  />
                </div>
              </template>
              <span>Черновик сохранён</span>
            </v-tooltip>

            <v-tooltip bottom :disabled="errors">
              <template #activator="{ on }">
                <div v-on="on">
                  <v-btn
                    v-if="!close && !readonly"
                    :loading="loading"
                    :disabled="!errors"
                    color="error"
                    outlined
                    rounded
                    class="ml-btn"
                    @click="$emit('showErrors')"
                    v-text="'Ошибки'"
                  />
                </div>
              </template>
              <span>Нет ошибок заполнения формы</span>
            </v-tooltip>

            <v-btn
              v-if="isShowUploadedBtn"
              color="primary"
              rounded
              disabled
              outlined
              class="ml-btn"
              v-text="submitted ? 'Ваш отчет загружен в систему' : 'Ваш отчет не был загружен в систему'"
            />

            <v-btn
              v-if="!close && !readonly"
              :loading="loading"
              :disabled="errors"
              color="primary"
              outlined
              rounded
              class="ml-btn"
              @click="$emit('submit')"
              v-text="intermediate ? 'Сдать промежуточный отчёт' : 'Сдать отчёт'"
            />
          </template>

          <v-btn
            v-if="withDraft && !readonly && false"
            color="primary"
            outlined
            rounded
            class="ml-btn"
            @click="$emit('draft:clear')"
            v-text="'Очистить черновик'"
          />

          <v-btn
            v-if="isExitVisible"
            :loading="loadingClosing"
            color="primary"
            outlined
            rounded
            class="ml-btn"
            @click="$emit('close')"
            v-text="'Закрыть'"
          />

          <v-tooltip v-if="expandable" bottom>
            <template #activator="{ on }">
              <v-btn
                icon
                outlined
                color="primary"
                class="ml-btn"
                v-on="on"
                @click.stop="$emit('table:expanded')"
              >
                <v-icon>
                  mdi-arrow-expand
                </v-icon>
              </v-btn>
            </template>
            <span>Раскрыть таблицу</span>
          </v-tooltip>
        </div>
        <div
          class="form-status"
          v-text="status"
        />
      </div>
    </div>


    <div
      class="LKPublicationsFormdataHeader__name"
      v-text="name"
    />
  </div>
</template>

<script>
import { lkFormdataMapper as StoreMapper } from '@/views/LKPublications/formdata/store'
import { FormdataStatuses } from '@/typings/api/Formdata'
import { uiDateFormatter } from '@/helpers/dateFormatter'

export default {
  name: 'LKPublicationsFormdataHeader',
  props: {
    loading: Boolean,
    loadingClosing: Boolean,
    withDraft: Boolean,
    intermediate: Boolean,
    close: Boolean,
    submitted: Boolean,
    readonly: Boolean,
    excel: Boolean,
    errors: Boolean,
    expandable: Boolean,
    updated: Boolean,
    name: {
      type: String,
      required: true,
    },
    useExcel: Boolean,
    revDate: String,
    sheets: {
      type: Array,
      default: () => [],
    },
    activeTab: {
      type: String,
      default: 'form',
    },
  },
  computed: {
    ...StoreMapper.mapState([
      'single',
    ]),
    hasScannable() {
      if (!this.single?.data_collection?.is_scannable) return false
      if (!this.sheets || !this.sheets.length) return false
      return this.sheets.some((sheet) => sheet.cells && sheet.cells.some((cell) => cell.is_scannable === true))
    },
    isExitVisible() {
      return !(this.$route.path?.includes('/detach/'))
    },
    status() {
      const { single } = this
      if (single?.status) {
        switch (single?.status) {
          case FormdataStatuses.close:
          case FormdataStatuses.submitted:
            return `Форма сдана, данные по состоянию на ${uiDateFormatter(single.submitted_at)} (мск) |
            Форма последний раз редактировалась ${uiDateFormatter(single.updated_at)} (мск)`
          default:
            return `Форма не сдана |
            Форма последний раз редактировалась ${uiDateFormatter(single.updated_at)} (мск)`
        }
      } else if (this.revDate) {
        return `Форма сдана, данные по состоянию на ${uiDateFormatter(this.revDate)} (мск) |
        Форма последний раз редактировалась ${uiDateFormatter(single.updated_at)} (мск)`
      } else {
        return `Форма не сдана |
        Форма последний раз редактировалась ${uiDateFormatter(single.updated_at)} (мск)`
      }
    },
    isShowUploadedBtn() {
      const { single } = this
      if (single?.status) {
        switch (single?.status) {
          case FormdataStatuses.close:
          case FormdataStatuses.submitted:
            return true
          default:
            return false
        }
      }
      return false
    },
  },
  methods: {
    onExcelClick() {
      this.$emit('tab:excel')
    },
    onFormClick() {
      this.$emit('tab:form')
    },
    onScanClick() {
      this.$emit('tab:scan')
    },
  },
}
</script>

<style lang="scss">
$modal-padding: 20px;

.LKPublicationsFormdataHeader {
  padding: 1rem;

  &__name {
    margin-top: 20px;
    font-size: 1.375rem;
    font-weight: 700;
    line-height: 1.7875rem;
  }

  @media screen and (max-width: #{800px + 2 * $modal-padding}) {
    flex-wrap: wrap;
    height: auto;
    padding: 10px;
  }

  .table-actions-wrapper {
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;
  }

  @import "~@/assets/scss/components/_LKHeaderButtons.scss";

  .ml-btn {
    margin-left: 12px;
  }

  .form-status {
    margin-top: 10px;
    color: $webflow-color-blue-dark-2;
    text-align: right;
  }
}
</style>
